<template>
  <div class="mobile-wrapper" :style="styles.pageColor">
    <div v-if="fetchingData">
      <Transition name="slide-fade">
        <progress-indicator />
      </Transition>
    </div>

    <div v-else>
      <div :class="showNewUi ? 'new-fixed-banner' : 'fixed-banner'">
        <div class="container-fluid banner-alt">
          <div class="row">
            <div class="col-12 banner-title">
              <span class="material-icons md-36" @click="goBack"
                >keyboard_arrow_left</span
              >
              <span class="title-text" @click="goBack">{{
                $t("message.myAccount")
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="justify-content-center">
        <div class="col-12 py-4">
          <form
            class="pt-4 mt-4 d-flex flex-wrap justify-content-center"
            @submit.prevent="submitForm"
          >
            <my-detail ref="myDetail" :edit-model="detailModel" />
            <cards :dbuser="dbuser" />
            <div
              v-if="success"
              class="alert alert-primary p-4 mt-4 alert-color w-100"
              role="alert"
            >
              {{ $t("message.profileSavedSuccessfully") }}
            </div>
            <div
              v-if="hasError"
              class="alert alert-danger p-4 mt-4 alert-color w-100"
              role="alert"
            >
              {{ hasError }}
            </div>
            <div class="w-100" style="margin-top: 4rem">
              <button
                :disabled="loading"
                type="submit"
                class="btn btn-lg btn-block shadow btn-primary d-flex justify-content-center align-items-center rounded"
                :style="getButtonStyles()"
              >
                {{ $t("message.saveChanges") }}
                <span v-show="loading">
                  <i class="spin ml-4" />
                </span>
              </button>
            </div>

            <Poweredby v-if="showNewUi" />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyDetail from "./MyDetail";
import cards from "./cardsMobile";
import { mapGetters } from "vuex";
import { getDBUser } from "../../api/services/userService.js";
import shared from "../../sharedscripts/user/profile.js";
import common from "../../sharedscripts/Common/commonMobile";
import Poweredby from "@/components/shared/poweredby";
import ProgressIndicator from "@/components/progressindicator";

export default {
  components: {
    Poweredby,
    MyDetail,
    cards,
    ProgressIndicator,
  },
  data() {
    return {
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
      },
      dbuser: {},
      hasError: "",
      success: false,
      loading: false,
      fetchingData: false,
      oldPhone: "",
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "currentStoreDoc",
      "mobileStyles",
      "styles",
      "viewConfig",
      "mobileStyles",
    ]),
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
  },
  async mounted() {
    if (this.user) {
      const res = await getDBUser(this.user.id).get();
      this.dbuser = res.data();
      this.oldPhone = this.dbuser ? this.dbuser.Mobile : "";
      this.initModel();
    }
  },
  methods: {
    ...shared.methods,
    ...common.methods,
    getButtonStyles() {
      let styles = [];

      if (this.showNewUi) {
        styles.push({
          borderRadius: "5px !important",
        });
      }
      styles.push(this.mobileStyles.btn);
      return styles;
    },
  },
};
</script>
